import Header from '../../components/feature/Header';
import Footer from '../home/components/Footer';

export default function PrivacyPage() {
  return (
    <>
      <Header />
      <div className="min-h-screen bg-white pt-20">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-teal-600 to-cyan-600 text-white py-20">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
            <h1 className="text-5xl lg:text-6xl font-bold mb-6">隐私政策</h1>
            <p className="text-xl lg:text-2xl max-w-3xl mx-auto leading-relaxed">
              我们重视您的隐私，致力于保护您的个人信息安全
            </p>
          </div>
        </section>

        {/* Privacy Policy Content */}
        <section className="py-20">
          <div className="max-w-4xl mx-auto px-6 lg:px-8">
            <div className="prose prose-lg max-w-none">
              <div className="mb-8">
                <p className="text-gray-600 text-lg">
                  最后更新时间：2025年1月1日
                </p>
              </div>

              <div className="space-y-12">
                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">1. 信息收集</h2>
                  <div className="space-y-4 text-gray-700">
                    <p>
                      我们可能收集以下类型的信息：
                    </p>
                    <ul className="list-disc pl-6 space-y-2">
                      <li><strong>个人身份信息</strong>：姓名、电子邮件地址、电话号码、公司名称等</li>
                      <li><strong>技术信息</strong>：IP地址、浏览器类型、设备信息、访问时间等</li>
                      <li><strong>使用数据</strong>：您如何使用我们的服务、功能使用情况、偏好设置等</li>
                      <li><strong>通信记录</strong>：与我们的客服或销售团队的沟通记录</li>
                    </ul>
                  </div>
                </div>

                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">2. 信息使用</h2>
                  <div className="space-y-4 text-gray-700">
                    <p>
                      我们使用收集的信息用于：
                    </p>
                    <ul className="list-disc pl-6 space-y-2">
                      <li>提供、维护和改进我们的服务</li>
                      <li>处理您的请求和提供客户支持</li>
                      <li>发送产品更新、安全警报和管理消息</li>
                      <li>进行数据分析以改善用户体验</li>
                      <li>遵守法律义务和保护我们的权利</li>
                    </ul>
                  </div>
                </div>

                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">3. 信息共享</h2>
                  <div className="space-y-4 text-gray-700">
                    <p>
                      我们不会出售、交易或租赁您的个人信息给第三方。我们可能在以下情况下共享信息：
                    </p>
                    <ul className="list-disc pl-6 space-y-2">
                      <li><strong>服务提供商</strong>：与帮助我们运营业务的可信第三方</li>
                      <li><strong>法律要求</strong>：当法律要求或为保护我们的权利时</li>
                      <li><strong>业务转让</strong>：在合并、收购或资产出售的情况下</li>
                      <li><strong>征得同意</strong>：在获得您明确同意的其他情况下</li>
                    </ul>
                  </div>
                </div>

                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">4. 数据安全</h2>
                  <div className="space-y-4 text-gray-700">
                    <p>
                      我们采用多种安全措施来保护您的个人信息：
                    </p>
                    <ul className="list-disc pl-6 space-y-2">
                      <li>使用SSL加密技术保护数据传输</li>
                      <li>实施访问控制和身份验证机制</li>
                      <li>定期进行安全审计和漏洞评估</li>
                      <li>员工接受数据保护培训</li>
                      <li>建立数据泄露应急响应计划</li>
                    </ul>
                  </div>
                </div>

                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">5. Cookie和跟踪技术</h2>
                  <div className="space-y-4 text-gray-700">
                    <p>
                      我们使用Cookie和类似技术来：
                    </p>
                    <ul className="list-disc pl-6 space-y-2">
                      <li>记住您的偏好设置</li>
                      <li>分析网站使用情况</li>
                      <li>提供个性化内容</li>
                      <li>改善网站性能</li>
                    </ul>
                    <p>
                      您可以通过浏览器设置控制Cookie的使用。
                    </p>
                  </div>
                </div>

                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">6. 您的权利</h2>
                  <div className="space-y-4 text-gray-700">
                    <p>
                      根据适用的数据保护法律，您拥有以下权利：
                    </p>
                    <ul className="list-disc pl-6 space-y-2">
                      <li><strong>访问权</strong>：请求获取我们持有的关于您的个人信息</li>
                      <li><strong>更正权</strong>：要求更正不准确或不完整的信息</li>
                      <li><strong>删除权</strong>：在某些情况下要求删除您的个人信息</li>
                      <li><strong>限制处理权</strong>：要求限制对您个人信息的处理</li>
                      <li><strong>数据可携权</strong>：以结构化格式获取您的数据</li>
                      <li><strong>反对权</strong>：反对某些类型的数据处理</li>
                    </ul>
                  </div>
                </div>

                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">7. 数据保留</h2>
                  <div className="space-y-4 text-gray-700">
                    <p>
                      我们仅在必要的时间内保留您的个人信息：
                    </p>
                    <ul className="list-disc pl-6 space-y-2">
                      <li>提供服务所需的时间</li>
                      <li>履行法律义务的时间</li>
                      <li>解决争议和执行协议的时间</li>
                    </ul>
                    <p>
                      当不再需要时，我们将安全地删除或匿名化您的个人信息。
                    </p>
                  </div>
                </div>

                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">8. 国际数据传输</h2>
                  <div className="space-y-4 text-gray-700">
                    <p>
                      您的信息可能会被传输到您所在国家/地区以外的地方进行处理。我们确保：
                    </p>
                    <ul className="list-disc pl-6 space-y-2">
                      <li>采用适当的保护措施</li>
                      <li>遵守适用的数据保护法律</li>
                      <li>与第三方签署数据处理协议</li>
                    </ul>
                  </div>
                </div>

                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">9. 儿童隐私</h2>
                  <div className="space-y-4 text-gray-700">
                    <p>
                      我们的服务不面向13岁以下的儿童。我们不会故意收集13岁以下儿童的个人信息。如果我们发现收集了此类信息，将立即删除。
                    </p>
                  </div>
                </div>

                <div>
                  <h2 className="text-3xl font-bold text-gray-900 mb-6">10. 政策更新</h2>
                  <div className="space-y-4 text-gray-700">
                    <p>
                      我们可能会不时更新本隐私政策。重大变更时，我们将：
                    </p>
                    <ul className="list-disc pl-6 space-y-2">
                      <li>在网站上发布更新的政策</li>
                      <li>通过电子邮件通知您</li>
                      <li>在服务中显示通知</li>
                    </ul>
                    <p>
                      继续使用我们的服务即表示您接受更新后的政策。
                    </p>
                  </div>
                </div>

                <div className="bg-teal-50 rounded-xl p-8 mt-12">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">联系我们</h2>
                  <div className="space-y-2 text-gray-700">
                    <p>
                      如果您对本隐私政策有任何疑问或需要行使您的权利，请通过以下方式联系我们：
                    </p>
                    <div className="mt-4 space-y-2">
                      <p><strong>邮箱：</strong> privacy@documogul.com</p>
                      <p><strong>电话：</strong> 400-838-9650</p>
                      <p><strong>地址：</strong> 中国广州市天河区灵山东路5号2层</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
}